import { createRoot } from "react-dom/client";

import { MainRoot } from "@/mainRoot";
import { initializePwaInstall } from "@/pwa/installStore";
import { registerPwa } from "@/pwa/register";

// Capture install availability before React or a lazy route mounts.
initializePwaInstall();
registerPwa();

const root = document.querySelector("#root")!;

const createdRoot = createRoot(root);

createdRoot.render(<MainRoot />);
